<template>
  <section>
    <div class="listview__head">
      <div>
        <div class="c-lbl">Facturación</div>
        <div class="listview__desc">
          {{ totales.total || 0 }} facturas · Total:
          <strong class="grad-text">{{ fmt(totales.monto) }}</strong>
        </div>
      </div>
      <div style="display:flex;gap:8px;">
        <button class="btn btn-g" @click="fetch" :disabled="loading" title="Refrescar listado">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" :class="{ spin: loading }"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
          Refrescar
        </button>
        <button class="btn btn-p" @click="openNew"><span>+</span> Nueva factura</button>
      </div>
    </div>

    <div class="listview__filters">
      <input class="fi" v-model="filters.q" @input="debouncedFetch" placeholder="Buscar por número o cliente..." />
      <select class="fi" v-model="filters.periodo" @change="fetch" style="max-width:170px">
        <option value="">Todos los períodos</option>
        <option v-for="p in periodos" :key="p.value" :value="p.value">{{ p.label }}</option>
      </select>
      <select class="fi" v-model="filters.estado" @change="fetch" style="max-width:160px">
        <option value="">Todos los estados</option>
        <option value="pendiente">Pendiente</option>
        <option value="parcial">Pago parcial</option>
        <option value="pagada">Pagada</option>
        <option value="vencida">Vencida</option>
        <option value="anulada">Anulada</option>
      </select>
      <select class="fi" v-model="filters.cliente_id" @change="onClienteChange" style="max-width:220px">
        <option value="">Todos los clientes</option>
        <option v-for="c in clientes" :key="c.id" :value="c.id">{{ c.nombre }}</option>
      </select>
    </div>

    <div class="card">
      <div class="tbl-wrap">
        <table class="tbl">
          <thead>
            <tr>
              <th>N°</th><th>Fecha</th><th>Cliente</th><th style="text-align:right">Monto</th><th>Estado</th><th style="width:160px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading"><td colspan="6" class="tbl-empty">Cargando...</td></tr>
            <tr v-else-if="!items.length"><td colspan="6" class="tbl-empty">Sin facturas cargadas.</td></tr>
            <tr v-for="f in items" :key="f.id">
              <td class="mono">{{ f.numero }}</td>
              <td>{{ fmtDate(f.fecha) }}</td>
              <td><strong style="color:var(--tx-hi)">{{ f.cliente?.nombre || '—' }}</strong></td>
              <td class="mono" style="text-align:right">{{ fmt(f.monto_total) }}</td>
              <td><span class="pill" :class="estadoPill(f.estado)">{{ f.estado }}</span></td>
              <td class="tbl-actions">
                <a v-if="f.cae" class="btn-ico" :href="pdfUrl(f.id)" target="_blank" rel="noopener" title="Ver PDF">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="15" x2="15" y2="15"/><line x1="9" y1="11" x2="15" y2="11"/></svg>
                </a>
                <button v-else class="btn-ico" disabled title="Sin CAE — autorizá primero">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                </button>
                <button class="btn-ico" @click="enviarEmail(f)" :title="f.cae ? 'Enviar por email' : 'Sin CAE'" :disabled="!f.cae || f._enviando">
                  <svg v-if="f._enviando" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="spin"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>
                  <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                </button>
                <button class="btn-ico" @click="openRecibo(f)" :title="reciboTitle(f)" :disabled="f.estado === 'anulada' || !f.cae">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" :opacity="(f.estado !== 'anulada' && f.cae) ? 1 : 0.3">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                    <line x1="12" y1="12" x2="12" y2="18"/>
                    <polyline points="9 15 12 18 15 15"/>
                  </svg>
                  <span v-if="(f.recibos || []).length" style="position:absolute;top:-5px;right:-5px;background:#1560BD;color:#fff;border-radius:8px;min-width:14px;height:14px;font-size:9px;line-height:14px;text-align:center;padding:0 3px;font-weight:700;">{{ f.recibos.length }}</span>
                </button>
                <button
                  class="btn-ico"
                  @click="openNotaCredito(f)"
                  :disabled="!f.cae || f.estado !== 'pendiente' || Number(f.cbte_tipo) === 13"
                  :title="nuCreditoTitle(f)"
                  style="color:#c0392b;"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h18v18H3z"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
                </button>
                <button class="btn-ico" @click="openEdit(f)" title="Editar">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                </button>
                <button
                  v-if="!f.cae"
                  class="btn-ico"
                  @click="eliminar(f)"
                  :disabled="f._deleting"
                  title="Eliminar (solo sin CAE)"
                  style="color:#c33"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="listview__pag" v-if="pagination.last_page > 1">
        <button class="btn btn-g btn-sm" :disabled="pagination.current_page <= 1" @click="go(pagination.current_page - 1)">‹ Anterior</button>
        <span>Página {{ pagination.current_page }} / {{ pagination.last_page }}</span>
        <button class="btn btn-g btn-sm" :disabled="pagination.current_page >= pagination.last_page" @click="go(pagination.current_page + 1)">Siguiente ›</button>
      </div>
    </div>

    <!-- Modal nueva factura libre -->
    <Modal v-model="nuevo.open" title="Nueva factura" :max-width="620">
      <form @submit.prevent="crearFactura" id="nueva-factura-form" class="form-grid">
        <div class="form-row form-row--2">
          <div><label class="fl">Cliente <span class="req">*</span></label>
            <select class="fi" v-model="nuevo.cliente_id" required @change="onNuevoClienteChange">
              <option value="">— Seleccionar —</option>
              <option v-for="c in clientes" :key="c.id" :value="c.id">{{ c.nombre }}</option>
            </select></div>
          <div><label class="fl">Emisor <span class="req">*</span></label>
            <select class="fi" v-model="nuevo.cuit_emisor" required @change="prefillNotaNueva">
              <option value="">— Seleccionar —</option>
              <option v-for="e in emisores" :key="e.id" :value="e.cuit">{{ e.razon_social }} (PV {{ e.pto_vta_ws }})</option>
            </select></div>
        </div>
        <div class="form-row form-row--3">
          <div><label class="fl">Período desde <span class="req">*</span></label>
            <input class="fi" type="date" v-model="nuevo.fch_serv_desde" required /></div>
          <div><label class="fl">Período hasta <span class="req">*</span></label>
            <input class="fi" type="date" v-model="nuevo.fch_serv_hasta" required @change="prefillNotaNueva" /></div>
          <div><label class="fl">Fecha emisión <span class="req">*</span></label>
            <input class="fi" type="date" v-model="nuevo.fecha" required @change="prefillNotaNueva" /></div>
        </div>

        <div style="margin-top:8px">
          <label class="fl">Detalle</label>
          <table style="width:100%;border-collapse:collapse;font-size:13px;">
            <tr style="background:var(--bg-alt)">
              <td style="padding:4px 8px;font-weight:600;">Código</td>
              <td style="padding:4px 8px;font-weight:600;">Descripción</td>
              <td style="padding:4px 8px;font-weight:600;width:130px;text-align:right;">Monto</td>
              <td style="width:32px;"></td>
            </tr>
            <tr v-for="(item, i) in nuevo.items" :key="i">
              <td style="padding:2px 4px;"><input class="fi" v-model="item.codigo" style="font-size:12px;" maxlength="10" /></td>
              <td style="padding:2px 4px;"><input class="fi" v-model="item.descripcion" style="font-size:12px;" /></td>
              <td style="padding:2px 4px;"><input class="fi" v-model.number="item.monto" type="number" step="0.01" min="0" style="font-size:12px;text-align:right;" /></td>
              <td style="padding:2px 4px;text-align:center;">
                <button type="button" class="btn-ico btn-ico--danger" @click="nuevo.items.splice(i, 1)" v-if="nuevo.items.length > 1" title="Quitar">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="padding:4px;">
                <button type="button" class="btn btn-g btn-sm" @click="nuevo.items.push({ codigo: '', descripcion: '', monto: 0 })">+ Agregar línea</button>
              </td>
              <td style="padding:4px 8px;text-align:right;font-weight:700;font-size:14px;color:var(--accent);">
                {{ fmtMonto(nuevoTotal) }}
              </td>
              <td></td>
            </tr>
          </table>
        </div>

        <div><label class="fl">Notas</label>
          <textarea class="fi" v-model="nuevo.notas" rows="2"></textarea></div>
        <div>
          <label class="fl">Nota impresa en la factura (gastos a recuperar)</label>
          <textarea class="fi" v-model="nuevo.nota_pdf" rows="3" maxlength="600"></textarea>
          <div v-if="nuevo.nota_aviso" class="form-error" style="margin-top:4px">{{ nuevo.nota_aviso }}</div>
          <div v-if="nuevo.nota_pdf" style="display:flex;justify-content:flex-end;margin-top:4px">
            <button type="button" class="btn btn-g btn-sm" style="color:#c33" @click="nuevo.nota_pdf = ''">Quitar nota</button>
          </div>
        </div>
        <div v-if="nuevo.error" class="form-error">{{ nuevo.error }}</div>
      </form>
      <template #footer>
        <button class="btn btn-g" @click="nuevo.open = false">Cancelar</button>
        <button class="btn btn-p" form="nueva-factura-form" type="submit" :disabled="nuevo.saving">
          {{ nuevo.saving ? 'Creando...' : 'Crear y autorizar' }}
        </button>
      </template>
    </Modal>

    <!-- Modal editar factura (solo estado + notas) -->
    <Modal v-model="modal.open" title="Editar factura" :max-width="480">
      <form @submit.prevent="save" id="factura-form" class="form-grid">
        <div class="fi fi--ro" style="font-size:12px;">
          <strong>{{ modal.clienteNombre }}</strong> — {{ modal.data.numero }} — ${{ fmtMonto(modal.data.monto_total) }}
        </div>
        <div v-if="!modal.data.cae" class="form-error" style="background:#fff7e6;border-color:#f5c16c;color:#945c00;">
          Esta factura aún no tiene CAE de ARCA. Podés reintentar la autorización.
        </div>
        <div>
          <label class="fl">Estado</label>
          <select class="fi" v-model="modal.data.estado">
            <option value="pendiente">Pendiente</option>
        <option value="parcial">Pago parcial</option>
            <option value="pagada">Pagada</option>
            <option value="vencida">Vencida</option>
            <option value="anulada">Anulada</option>
          </select>
        </div>
        <div><label class="fl">Notas</label><textarea class="fi" v-model="modal.data.notas" rows="2"></textarea></div>
        <div v-if="!modal.data.cae">
          <label class="fl">Nota impresa en la factura (gastos a recuperar)</label>
          <textarea class="fi" v-model="modal.data.nota_pdf" rows="3" maxlength="600"></textarea>
          <div v-if="modal.data.nota_pdf" style="display:flex;justify-content:flex-end;margin-top:4px">
            <button type="button" class="btn btn-g btn-sm" style="color:#c33" @click="modal.data.nota_pdf = ''">Quitar nota de esta factura</button>
          </div>
        </div>
        <div v-else-if="modal.data.nota_pdf">
          <label class="fl">Nota impresa en la factura</label>
          <div class="fi fi--ro" style="font-size:12px;white-space:pre-wrap">{{ modal.data.nota_pdf }}</div>
        </div>
        <div v-if="modal.error" class="form-error">{{ modal.error }}</div>
      </form>
      <template #footer>
        <button v-if="!modal.data.cae" class="btn btn-a" @click="autorizar" :disabled="modal.authorizing">
          {{ modal.authorizing ? 'Autorizando...' : 'Autorizar en ARCA' }}
        </button>
        <button class="btn btn-g" @click="modal.open = false">Cancelar</button>
        <button class="btn btn-p" form="factura-form" type="submit" :disabled="modal.saving">
          {{ modal.saving ? 'Guardando...' : 'Guardar' }}
        </button>
      </template>
    </Modal>

    <!-- Modal Nota de Crédito -->
    <Modal v-model="nc.open" title="Emitir Nota de Crédito" :max-width="500">
      <div style="font-size:13px;color:#333;line-height:1.5;">
        <p style="margin:0 0 10px;">
          Vas a emitir una <strong>Nota de Crédito C</strong> que anula la siguiente factura
          ante AFIP. La operación se registra como válida fiscalmente y
          <strong>no se puede revertir</strong>.
        </p>
        <div style="background:#f5f5f5;border:1px solid #ddd;padding:10px;border-radius:6px;margin:10px 0;font-size:12px;">
          <div><strong>Factura:</strong> {{ nc.data.numero }}</div>
          <div><strong>Cliente:</strong> {{ nc.data.cliente }}</div>
          <div><strong>Monto:</strong> $ {{ fmtMonto(nc.data.monto) }}</div>
          <div><strong>CAE original:</strong> {{ nc.data.cae }}</div>
        </div>
        <p style="margin:12px 0 10px;">¿Estás seguro de emitir la Nota de Crédito?</p>
        <label style="display:flex;align-items:center;gap:8px;font-size:13px;cursor:pointer;padding:8px;background:#fff7e6;border:1px solid #f5c16c;border-radius:6px;">
          <input type="checkbox" v-model="nc.confirmado" />
          <span>Confirmo que quiero emitir esta Nota de Crédito</span>
        </label>
        <div v-if="nc.error" class="form-error" style="margin-top:10px;">{{ nc.error }}</div>
      </div>
      <template #footer>
        <button class="btn btn-g" @click="nc.open = false" :disabled="nc.emitting">Cancelar</button>
        <button
          class="btn btn-p"
          @click="confirmarNotaCredito"
          :disabled="!nc.confirmado || nc.emitting"
          style="background:#c0392b;border-color:#c0392b;"
        >
          {{ nc.emitting ? 'Emitiendo...' : 'Emitir Nota de Crédito' }}
        </button>
      </template>
    </Modal>

    <!-- Modal Recibo (crear/editar) -->
    <Modal v-model="recibo.open" :title="recibo.id ? 'Editar recibo' : 'Nuevo recibo'" :max-width="620">
      <form @submit.prevent="saveRecibo" id="recibo-form" class="form-grid">
        <div class="fi fi--ro" style="font-size:12px;">
          <strong>{{ recibo.clienteNombre }}</strong> — Factura {{ recibo.facturaNumero }}
          <span v-if="recibo.facturaEstado"> · <span class="pill" :class="estadoPill(recibo.facturaEstado)">{{ recibo.facturaEstado }}</span></span>
          <span v-if="recibo.data.numero"> · Recibo <strong>{{ recibo.data.numero }}</strong></span>
        </div>

        <!-- Recibos ya emitidos para esta factura (pagos fraccionados) -->
        <div v-if="(recibo.lista || []).length && !recibo.id">
          <label class="fl">Recibos ya emitidos para esta factura</label>
          <table class="tbl" style="font-size:12.5px;">
            <tr v-for="r in recibo.lista" :key="r.id">
              <td class="mono">{{ r.numero }}</td>
              <td>{{ fmtDate(r.fecha_pago) }}</td>
              <td class="mono" style="text-align:right;">$ {{ fmtMonto(r.monto) }}</td>
              <td style="text-align:right;white-space:nowrap;">
                <a class="btn btn-g btn-sm" :href="reciboPdfUrl(r.id)" target="_blank" rel="noopener">PDF</a>
                <button type="button" class="btn btn-g btn-sm" @click="editarRecibo(r)">Editar</button>
              </td>
            </tr>
          </table>
        </div>

        <div class="form-grid" style="grid-template-columns:1fr 1fr;gap:10px;">
          <div>
            <label class="fl">Fecha de pago *</label>
            <input class="fi" type="date" v-model="recibo.data.fecha_pago" required />
          </div>
          <div>
            <label class="fl">Monto cobrado *</label>
            <input class="fi" type="number" step="0.01" min="0.01" v-model.number="recibo.data.monto" required @input="previewDebounced" />
            <div v-if="!recibo.id && recibo.totalPendiente" class="xs" style="margin-top:4px;color:var(--tx-md);">
              Pendiente del cliente con este emisor: $ {{ fmtMonto(recibo.totalPendiente) }}
              <a href="#" @click.prevent="recibo.data.monto = recibo.totalPendiente; loadPreview()" style="color:var(--accent);">cobrar todo</a>
            </div>
          </div>
        </div>

        <!-- Cómo se aplica el pago (FIFO): factura más vieja → su recupero → siguiente -->
        <div v-if="!recibo.id && ((recibo.plan || []).length || recibo.sobrante > 0)"
             style="border:1px solid var(--brd,#dbe3ea);border-radius:8px;padding:10px 12px;background:#f6f9fd;font-size:12.5px;">
          <div class="fl" style="margin-bottom:6px;">Cómo se aplica este pago</div>
          <div v-for="(p, i) in recibo.plan" :key="i" style="display:flex;justify-content:space-between;gap:10px;padding:3px 0;border-bottom:1px dotted #dde5ec;">
            <span>
              <template v-if="p.tipo === 'factura'">Factura {{ p.numero }} <span class="xs" style="color:var(--tx-md);">{{ p.periodo }}</span></template>
              <template v-else>Gastos a recuperar <span class="xs" style="color:var(--tx-md);">{{ p.periodo }} · US$ {{ fmtMonto(p.aplica_usd) }} × {{ fmtMonto(p.tc) }}</span></template>
              <span v-if="!p.cubre_total" class="pill pill-a" style="margin-left:6px;">parcial</span>
              <span v-else-if="p.tipo === 'gastos'" class="pill pill-g" style="margin-left:6px;">cierra el tramo</span>
            </span>
            <strong class="mono" style="white-space:nowrap;">$ {{ fmtMonto(p.aplica_ars) }}</strong>
          </div>
          <div v-if="recibo.sobrante > 0" class="form-error" style="margin-top:8px;">
            El monto supera lo pendiente ($ {{ fmtMonto(recibo.totalPendiente) }}): sobran $ {{ fmtMonto(recibo.sobrante) }}.
          </div>
        </div>
        <div v-else-if="recibo.id" class="xs" style="color:var(--tx-md);">
          Si cambiás el monto, el pago se vuelve a aplicar FIFO al guardar.
        </div>
        <div class="form-grid" style="grid-template-columns:1fr 1fr;gap:10px;">
          <div>
            <label class="fl">Método de pago</label>
            <select class="fi" v-model="recibo.data.metodo_pago">
              <option value="">—</option>
              <option value="transferencia">Transferencia</option>
              <option value="efectivo">Efectivo</option>
              <option value="cheque">Cheque</option>
            </select>
          </div>
          <div style="position:relative">
            <label class="fl">Banco</label>
            <!-- Autocompletar con la lista de entidades del BCRA (config/bancos.php); texto libre si no está -->
            <input class="fi" type="text" v-model="recibo.data.banco" maxlength="100" autocomplete="off"
                   placeholder="Galicia, Nación, ICBC…"
                   @focus="bancoFoco = true" @blur="cerrarBancos" @keydown.escape="bancoFoco = false" />
            <div v-if="bancoFoco && bancosFiltrados().length"
                 style="position:absolute;z-index:30;left:0;right:0;top:100%;margin-top:2px;background:#fff;border:1px solid #dbe3ea;border-radius:8px;box-shadow:0 8px 20px rgba(3,43,82,.12);max-height:230px;overflow:auto">
              <div v-for="b in bancosFiltrados()" :key="b.nombre" @mousedown.prevent="elegirBanco(b)"
                   style="padding:6px 10px;cursor:pointer;border-bottom:1px solid #f0f3f6;font-size:13px;line-height:1.3">
                <div style="font-weight:600;color:#032B52">{{ b.corto }}</div>
                <div style="font-size:11.5px;color:#66788A">{{ b.nombre }}<template v-if="b.codigo"> · BCRA {{ b.codigo }}</template></div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <label class="fl">Referencia (N° transferencia, cheque, etc.)</label>
          <input class="fi" type="text" v-model="recibo.data.referencia" maxlength="80" />
        </div>
        <div>
          <label class="fl">Notas</label>
          <textarea class="fi" v-model="recibo.data.notas" rows="2" maxlength="500"></textarea>
        </div>
        <div v-if="recibo.resultado" style="border:1px solid #c8e6c9;border-radius:8px;padding:10px 12px;background:#e8f5e9;font-size:12.5px;color:#1b5e20;">
          <div style="font-weight:700;margin-bottom:4px;">Recibo {{ recibo.data.numero }} aplicado</div>
          <div v-for="(a, i) in recibo.resultado.aplicaciones" :key="i">
            {{ a.tipo === 'factura' ? 'Factura' : 'Gastos a recuperar' }} {{ a.numero }} ({{ a.periodo }}): $ {{ fmtMonto(a.monto_ars) }}<span v-if="a.tipo === 'gastos'"> · US$ {{ fmtMonto(a.monto_usd) }}</span>
          </div>
          <div v-for="(av, i) in recibo.resultado.avisos" :key="'av' + i" style="margin-top:4px;">
            <template v-if="av.tipo === 'tramo_cerrado'">
              ✉ {{ av.ok ? 'Aviso RECUPERO enviado' : 'FALLÓ el aviso RECUPERO' }} — tramo {{ av.factura }} cerrado (cubre hasta {{ av.cubre_hasta }}, US$ {{ fmtMonto(av.importe_usd) }})<span v-if="!av.ok">: {{ av.error }}</span>
              <button v-if="!av.ok" type="button" class="btn btn-g btn-sm" style="margin-left:6px;" @click="reenviarRecupero(av)">Reintentar aviso</button>
            </template>
            <template v-else-if="av.tipo === 'tramo_reabierto'">
              ⚠️ {{ av.ok ? 'Aviso TRAMO REABIERTO enviado' : 'FALLÓ el aviso de tramo reabierto' }} — {{ av.factura }} (cubre hasta {{ av.cubre_hasta }}) vuelve a tener pendiente US$ {{ fmtMonto(av.pendiente_usd) }}<span v-if="!av.ok">: {{ av.error }}</span>
            </template>
            <template v-else>
              ✉ {{ av.ok ? 'Aviso parcial enviado' : 'FALLÓ el aviso parcial' }} — {{ av.factura }}: US$ {{ fmtMonto(av.importe_usd) }}, pendiente del tramo US$ {{ fmtMonto(av.pendiente_usd) }}<span v-if="!av.ok">: {{ av.error }}</span>
            </template>
          </div>
        </div>
        <div v-if="recibo.error" class="form-error">{{ recibo.error }}</div>
      </form>
      <template #footer>
        <button v-if="recibo.id" class="btn btn-g btn-sm" @click="deleteRecibo" :disabled="recibo.saving" style="margin-right:auto;color:#c33;">
          Eliminar
        </button>
        <a v-if="recibo.id" class="btn btn-g" :href="reciboPdfUrl(recibo.id)" target="_blank" rel="noopener">PDF</a>
        <button v-if="recibo.id" class="btn btn-g" @click="enviarReciboEmail" :disabled="recibo.sending">
          {{ recibo.sending ? 'Enviando...' : 'Enviar email' }}
        </button>
        <button class="btn btn-g" @click="recibo.open = false">Cancelar</button>
        <button class="btn btn-p" form="recibo-form" type="submit" :disabled="recibo.saving">
          {{ recibo.saving ? 'Guardando...' : (recibo.id ? 'Actualizar' : 'Crear') }}
        </button>
      </template>
    </Modal>

  </section>
</template>

<script>
import api from '../services/api';
import Modal from '../components/Modal.vue';

const API_BASE = process.env.VUE_APP_API_URL || 'http://localhost:8000/api';

const NOTA_TEXTO_DEFAULT =
  'GASTOS A RECUPERAR — Gastos de infraestructura pendientes de reintegro '
  + 'al {fecha}: US$ {importe}. Equivalen a $ {importe_ars} al tipo de cambio BNA '
  + '{tipo_cotizacion} del {fecha_factura} ($ {cotizacion} por dólar). Comprobantes en mhlm.ar/gastos. '
  + 'Importe informativo; no integra el total de esta factura.';

function empty() {
  return {
    cliente_id: null, numero: '', fecha: new Date().toISOString().slice(0,10),
    vencimiento: '', monto_total: 0, estado: 'pendiente', moneda: 'ARS', notas: ''
  };
}

export default {
  name: 'InvoiceListView',
  components: { Modal },
  data() {
    return {
      items: [], loading: false, clientes: [], periodos: [],
      totales: { total: 0, monto: 0 },
      pagination: { current_page: 1, last_page: 1, total: 0 },
      filters: { q: '', estado: '', cliente_id: '', periodo: '', page: 1 },
      modal:   { open: false, id: null, data: empty(), saving: false, error: '', clienteNombre: '' },
      nuevo:   { open: false, cliente_id: '', cuit_emisor: '', fecha: '', fch_serv_desde: '', fch_serv_hasta: '', items: [{ codigo: '', descripcion: '', monto: 0 }], notas: '', nota_pdf: '', nota_aviso: '', saving: false, error: '' },
      nc:      { open: false, facturaId: null, confirmado: false, emitting: false, error: '', data: { numero: '', cliente: '', monto: 0, cae: '' } },
      recibo:  { open: false, id: null, facturaId: null, facturaNumero: '', clienteNombre: '', saving: false, sending: false, error: '',
                 data: { numero: '', fecha_pago: '', monto: 0, metodo_pago: '', banco: '', referencia: '', notas: '' } },
      emisores: [],
      bancos: [],          // referencia de entidades (GET /bancos) para autocompletar el recibo
      bancoFoco: false,
      _debounce: null
    };
  },
  computed: {
    nuevoTotal() { return (this.nuevo.items || []).reduce((s, i) => s + (Number(i.monto) || 0), 0); },
    token() {
      try { return JSON.parse(localStorage.getItem('mhlm.session'))?.token || ''; } catch { return ''; }
    }
  },
  async mounted() {
    await Promise.all([this.loadPeriodos(), this.loadClientes(), this.loadEmisores(), this.loadBancos()]);
    await this.fetch();
  },
  methods: {
    debouncedFetch() { clearTimeout(this._debounce); this._debounce = setTimeout(() => this.fetch(), 250); },
    pdfUrl(id) { return `${API_BASE}/facturas/${id}/pdf?token=${this.token}`; },
    onClienteChange() { this.filters.periodo = ''; this.fetch(); },
    openNew() {
      const hoy = new Date().toLocaleDateString('en-CA'); // YYYY-MM-DD en zona local, no UTC
      this.nuevo = {
        open: true, saving: false, error: '',
        cliente_id: '', cuit_emisor: '', fecha: hoy,
        fch_serv_desde: '', fch_serv_hasta: '',
        items: [{ codigo: '', descripcion: '', monto: 0 }],
        notas: '', nota_pdf: ''
      };
    },
    onNuevoClienteChange() {
      const cli = this.clientes.find(c => c.id === this.nuevo.cliente_id);
      if (!cli) return;
      // Emisor por defecto: la facturación activa del cliente; si no hay, el campo legacy.
      const fact = (cli.facturaciones || []).find(f => f.activa) || (cli.facturaciones || [])[0];
      if (fact?.cuit_emisor) this.nuevo.cuit_emisor = fact.cuit_emisor;
      else if (cli.cuit_emisor) this.nuevo.cuit_emisor = cli.cuit_emisor;
      this.prefillNotaNueva();
    },
    // Precarga la nota de gastos a recuperar desde la config (cliente, emisor).
    // El formulario es el punto de revisión: se puede editar o quitar antes de emitir.
    async prefillNotaNueva() {
      // Foto de los inputs al arrancar + número de secuencia: si el usuario cambia
      // fecha/cliente mientras se consulta, la respuesta vieja se descarta.
      const seq = (this._prefillSeq = (this._prefillSeq || 0) + 1);
      const { cliente_id, cuit_emisor, fecha, fch_serv_hasta } = this.nuevo;
      const cli = this.clientes.find(c => c.id === cliente_id);
      const conf = (cli?.facturaciones || []).find(f => f.cuit_emisor === cuit_emisor);
      this.nuevo.nota_aviso = '';
      if (!conf || !conf.nota_gastos_activa) { this.nuevo.nota_pdf = ''; return; }
      const tipo = conf.cotizacion_tipo || 'compra';

      // Tipo de cambio BNA de la fecha de emisión (compra/venta según la config del cliente).
      let tc = null;
      try {
        const { data } = await api.get('/fe/cotizacion', { params: { fecha } });
        tc = Number(data?.[tipo] || data?.compra || 0) || null;
      } catch (e) { tc = null; }
      if (seq !== this._prefillSeq) return;

      // El pendiente se lee EN LÍNEA de mhlm.ar/gastos (al fin del período de servicio)
      // y el backend compone la nota con ese número.
      let nota = '', aviso = '';
      try {
        const { data } = await api.get('/gastos-recupero', { params: {
          cliente_id, cuit_emisor, fecha: fch_serv_hasta || fecha, fecha_factura: fecha, tc: tc || undefined,
        } });
        nota = data.nota_pdf || '';
        aviso = data.ok ? (data.aviso || '') : (data.aviso || data.error || 'No se pudo leer mhlm.ar/gastos.');
      } catch (e) {
        aviso = e?.response?.data?.message || 'No se pudo leer el pendiente de gastos en mhlm.ar/gastos.';
      }
      if (seq !== this._prefillSeq) return;
      this.nuevo.nota_pdf = nota;
      this.nuevo.nota_aviso = aviso;
    },
    async loadBancos() {
      try {
        const { data } = await api.get('/bancos');
        this.bancos = data.data || [];
      } catch (e) { this.bancos = []; }
    },
    // Sugerencias para el campo Banco: busca por nombre corto, razón social o código BCRA,
    // sin importar mayúsculas ni acentos. Sin texto muestra las más usadas (primeras de la lista).
    bancosFiltrados() {
      const norm = s => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
      const q = norm(this.recibo.data.banco);
      const lista = q
        ? this.bancos.filter(b => norm(b.corto).includes(q) || norm(b.nombre).includes(q) || String(b.codigo || '').includes(q))
        : this.bancos;
      // Si lo escrito ya es exactamente una entidad de la lista, no hay nada que sugerir.
      if (q && lista.length === 1 && norm(lista[0].nombre) === q) return [];
      return lista.slice(0, 8);
    },
    elegirBanco(b) {
      this.recibo.data.banco = b.nombre;
      this.bancoFoco = false;
    },
    cerrarBancos() {
      // Pequeña espera para que el mousedown de la opción se procese antes de ocultar la lista.
      setTimeout(() => { this.bancoFoco = false; }, 120);
    },
    async loadEmisores() {
      try {
        const { data } = await api.get('/emisores');
        this.emisores = data.data || [];
      } catch (e) { if (!e?.isAuthExpired) console.warn('[emisores]', e); }
    },
    async crearFactura() {
      if (!this.nuevo.cliente_id || !this.nuevo.cuit_emisor) {
        this.nuevo.error = 'Seleccioná cliente y emisor.'; return;
      }
      if (this.nuevoTotal <= 0) {
        this.nuevo.error = 'El monto total debe ser mayor a 0.'; return;
      }
      this.nuevo.saving = true; this.nuevo.error = '';
      try {
        const emisor = this.emisores.find(e => e.cuit === this.nuevo.cuit_emisor);
        const { data } = await api.post('/fe/factura-libre', {
          cliente_id: this.nuevo.cliente_id,
          cuit_emisor: this.nuevo.cuit_emisor,
          pto_vta: emisor?.pto_vta_ws || 1,
          fecha: this.nuevo.fecha,
          fch_serv_desde: this.nuevo.fch_serv_desde,
          fch_serv_hasta: this.nuevo.fch_serv_hasta,
          items: this.nuevo.items.filter(i => i.monto > 0),
          notas: this.nuevo.notas,
          nota_pdf: this.nuevo.nota_pdf || null,
        });
        this.nuevo.open = false;
        await this.fetch();
        if (data.factura?.cae) {
          this.$msg.success(`Factura autorizada: ${data.factura.numero}\nCAE: ${data.factura.cae}`, 'Factura creada');
        }
      } catch (e) {
        this.nuevo.error = e?.response?.data?.message || 'Error al crear factura.';
      } finally { this.nuevo.saving = false; }
    },
    async loadPeriodos() {
      try {
        const { data } = await api.get('/facturas/periodos');
        this.periodos = data.periodos || [];
        if (data.default) this.filters.periodo = data.default;
      } catch (e) {
        if (!e?.isAuthExpired) console.warn('[Periodos]', e);
      }
    },
    async loadClientes() {
      try {
        const { data } = await api.get('/clientes', { params: { per_page: 200 } });
        this.clientes = data.data.data;
      } catch (e) {
        if (!e?.isAuthExpired) console.warn('[Clientes list]', e);
      }
    },
    async fetch() {
      this.loading = true;
      try {
        const { data } = await api.get('/facturas', { params: { ...this.filters, per_page: 25 } });
        const p = data.data;
        this.items = p.data;
        this.totales = data.totales || { total: 0, monto: 0 };
        this.pagination = { current_page: p.current_page, last_page: p.last_page, total: p.total };
      } catch (e) {
        if (!e?.isAuthExpired) console.warn('[Facturas]', e);
      } finally { this.loading = false; }
    },
    go(page) { this.filters.page = page; this.fetch(); },
    openEdit(f) {
      this.modal = {
        open: true, id: f.id,
        clienteNombre: f.cliente?.nombre || '—',
        data: {
          estado: f.estado,
          notas: f.notas || '',
          nota_pdf: f.nota_pdf || '',
          numero: f.numero,
          monto_total: Number(f.monto_total),
          cae: f.cae,
        },
        saving: false, authorizing: false, error: ''
      };
    },
    async autorizar() {
      this.modal.authorizing = true; this.modal.error = '';
      try {
        const { data } = await api.post(`/facturas/${this.modal.id}/autorizar`);
        this.$msg.success(`Factura autorizada. CAE: ${data.cae}`);
        this.modal.open = false;
        await this.fetch();
      } catch (e) {
        this.modal.error = e?.response?.data?.message || 'No se pudo autorizar en ARCA.';
      } finally { this.modal.authorizing = false; }
    },
    nuCreditoTitle(f) {
      if (Number(f.cbte_tipo) === 13) return 'Es Nota de Crédito';
      if (f.estado !== 'pendiente') return `Solo facturas pendientes (esta: ${f.estado})`;
      if (!f.cae) return 'Sin CAE — no se puede emitir NC';
      return 'Emitir Nota de Crédito para anular';
    },
    openNotaCredito(f) {
      if (!f.cae || f.estado !== 'pendiente' || Number(f.cbte_tipo) === 13) return;
      this.nc = {
        open: true,
        facturaId: f.id,
        confirmado: false,
        emitting: false,
        error: '',
        data: {
          numero: f.numero,
          cliente: f.cliente?.nombre || '—',
          monto: Number(f.monto_total),
          cae: f.cae,
        },
      };
    },
    async confirmarNotaCredito() {
      if (!this.nc.confirmado) return;
      this.nc.emitting = true; this.nc.error = '';
      try {
        const { data } = await api.post(`/facturas/${this.nc.facturaId}/nota-credito`, { confirmado: true });
        this.nc.open = false;
        this.$msg.success(`NC emitida: ${data.nc.numero}. CAE: ${data.nc.cae}`, 'Nota de crédito');
        await this.fetch();
      } catch (e) {
        this.nc.error = e?.response?.data?.message || 'No se pudo emitir la NC.';
      } finally { this.nc.emitting = false; }
    },
    async save() {
      this.modal.saving = true; this.modal.error = '';
      try {
        const payload = { estado: this.modal.data.estado, notas: this.modal.data.notas };
        if (!this.modal.data.cae) payload.nota_pdf = this.modal.data.nota_pdf || null;
        await api.put(`/facturas/${this.modal.id}`, payload);
        this.modal.open = false;
        await this.fetch();
      } catch (e) {
        this.modal.error = e?.response?.data?.message || 'No se pudo guardar.';
      } finally { this.modal.saving = false; }
    },
    async enviarEmail(f) {
      if (!f.cae) return;
      const ok = await this.$msg.confirm(`Enviar factura ${f.numero} por email a ${f.cliente?.nombre || 'cliente'}?`, 'Enviar email');
      if (!ok) return;
      f._enviando = true;
      try {
        const { data } = await api.post(`/facturas/${f.id}/enviar-email`);
        this.$msg.success(data.message || 'Email enviado', 'Enviado');
      } catch (e) {
        this.$msg.error(e?.response?.data?.message || 'Error al enviar email');
      } finally { f._enviando = false; }
    },
    async eliminar(f) {
      if (f.cae) {
        this.$msg.error('No se puede borrar una factura con CAE. Usá Nota de Crédito.');
        return;
      }
      const ok = await this.$msg.confirm(
        `Eliminar la factura ${f.numero || '(pendiente)'} de ${f.cliente?.nombre || 'este cliente'}? Esta acción es irreversible.`,
        'Eliminar factura'
      );
      if (!ok) return;
      f._deleting = true;
      try {
        await api.delete(`/facturas/${f.id}`);
        this.$msg.success('Factura eliminada', 'OK');
        await this.fetch();
      } catch (e) {
        this.$msg.error(e?.response?.data?.message || 'No se pudo eliminar la factura.');
        f._deleting = false;
      }
    },
    reciboTitle(f) {
      if (f.estado === 'anulada') return 'Factura anulada';
      if (!f.cae) return 'Sin CAE — autorizá primero';
      const n = (f.recibos || []).length;
      if (!n) return 'Registrar pago (recibo)';
      return `${n} recibo${n > 1 ? 's' : ''} · registrar otro pago`;
    },
    reciboPdfUrl(id) { return `${API_BASE}/recibos/${id}/pdf?token=${this.token}`; },
    openRecibo(f) {
      if (f.estado === 'anulada' || !f.cae) return;
      const hoy = new Date().toLocaleDateString('en-CA');
      this.recibo = {
        open: true, id: null, facturaId: f.id,
        facturaNumero: f.numero, facturaEstado: f.estado, clienteNombre: f.cliente?.nombre || '—',
        lista: f.recibos || [],
        plan: [], sobrante: 0, totalPendiente: 0, sugerido: 0, resultado: null,
        saving: false, sending: false, error: '',
        data: {
          numero: '',
          fecha_pago: hoy,
          monto: null,
          metodo_pago: '', banco: '', referencia: '', notas: '',
        }
      };
      this.loadPreview();
    },
    // Cargar un recibo existente en el formulario para editarlo.
    editarRecibo(r) {
      this.recibo.id = r.id;
      this.recibo.plan = []; this.recibo.sobrante = 0; this.recibo.resultado = null; this.recibo.error = '';
      this.recibo.data = {
        numero: r.numero,
        fecha_pago: String(r.fecha_pago).slice(0, 10),
        monto: Number(r.monto),
        metodo_pago: r.metodo_pago || '',
        banco: r.banco || '',
        referencia: r.referencia || '',
        notas: r.notas || '',
      };
    },
    // Plan FIFO para el monto actual (solo al crear). Sugiere lo pendiente de
    // esta factura + su recupero si el monto está vacío.
    async loadPreview() {
      if (this.recibo.id || !this.recibo.facturaId) return;
      try {
        const params = {};
        if (this.recibo.data.monto > 0) params.monto = this.recibo.data.monto;
        const { data } = await api.get(`/facturas/${this.recibo.facturaId}/pago-preview`, { params });
        this.recibo.totalPendiente = Number(data.total_pendiente || 0);
        this.recibo.sugerido = Number(data.sugerido || 0);
        if (!(this.recibo.data.monto > 0)) this.recibo.data.monto = this.recibo.sugerido || null;
        this.recibo.plan = data.plan || [];
        this.recibo.sobrante = Number(data.sobrante || 0);
      } catch (e) {
        this.recibo.plan = [];
        if (!e?.isAuthExpired) console.warn('[pago-preview]', e);
      }
    },
    previewDebounced() {
      clearTimeout(this._previewTimer);
      this._previewTimer = setTimeout(() => this.loadPreview(), 350);
    },
    async saveRecibo() {
      this.recibo.saving = true; this.recibo.error = '';
      const payload = {
        fecha_pago:  this.recibo.data.fecha_pago,
        monto:       this.recibo.data.monto,
        metodo_pago: this.recibo.data.metodo_pago || null,
        banco:       this.recibo.data.banco || null,
        referencia:  this.recibo.data.referencia || null,
        notas:       this.recibo.data.notas || null,
      };
      try {
        if (this.recibo.id) {
          const { data } = await api.put(`/recibos/${this.recibo.id}`, payload);
          this.recibo.data.numero = data.recibo.numero;
          this.recibo.resultado = (data.aplicaciones || []).length ? { aplicaciones: data.aplicaciones, avisos: data.avisos || [] } : null;
          this.$msg.success('Recibo actualizado');
        } else {
          const { data } = await api.post(`/facturas/${this.recibo.facturaId}/recibo`, payload);
          this.recibo.id = data.recibo.id;
          this.recibo.data.numero = data.recibo.numero;
          this.recibo.resultado = { aplicaciones: data.aplicaciones || [], avisos: data.avisos || [] };
          this.recibo.plan = [];
          this.$msg.success(`Recibo ${data.recibo.numero} creado`);
        }
        await this.fetch();
      } catch (e) {
        this.recibo.error = e?.response?.data?.message || 'No se pudo guardar el recibo.';
      } finally { this.recibo.saving = false; }
    },
    async reenviarRecupero(av) {
      if (!av.factura_id) return;
      try {
        const { data } = await api.post(`/facturas/${av.factura_id}/reenviar-recupero`);
        const nuevo = (data.avisos || [])[0];
        if (nuevo) Object.assign(av, nuevo);
        if (nuevo?.ok) this.$msg.success('Aviso RECUPERO reenviado');
        else this.$msg.error(nuevo?.error || 'No se pudo reenviar el aviso.');
      } catch (e) {
        this.$msg.error(e?.response?.data?.message || 'No se pudo reenviar el aviso.');
      }
    },
    async deleteRecibo() {
      const ok = await this.$msg.confirm(`Eliminar el recibo ${this.recibo.data.numero}? Esta acción no se puede deshacer.`, 'Eliminar recibo');
      if (!ok) return;
      this.recibo.saving = true;
      try {
        const { data } = await api.delete(`/recibos/${this.recibo.id}`);
        const reabiertos = (data?.avisos || []).filter(a => a.tipo === 'tramo_reabierto');
        this.$msg.success(reabiertos.length
          ? `Recibo eliminado. Tramo de gastos reabierto: ${reabiertos.map(a => `${a.factura} (US$ ${this.fmtMonto(a.pendiente_usd)} pendiente)`).join(', ')} — se avisó por mail.`
          : 'Recibo eliminado');
        this.recibo.open = false;
        await this.fetch();
      } catch (e) {
        this.$msg.error(e?.response?.data?.message || 'No se pudo eliminar.');
      } finally { this.recibo.saving = false; }
    },
    async enviarReciboEmail() {
      if (!this.recibo.id) return;
      const ok = await this.$msg.confirm(`Enviar el recibo ${this.recibo.data.numero} al cliente por email?`, 'Enviar recibo');
      if (!ok) return;
      this.recibo.sending = true;
      try {
        const { data } = await api.post(`/recibos/${this.recibo.id}/enviar-email`);
        this.$msg.success(data.message || 'Recibo enviado');
      } catch (e) {
        this.$msg.error(e?.response?.data?.message || 'Error al enviar el recibo');
      } finally { this.recibo.sending = false; }
    },
    fmtMonto(n) { return Number(n || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }); },
    estadoPill(e) { return ({ pendiente: 'pill-a', parcial: 'pill-a', pagada: 'pill-g', vencida: 'pill-r', anulada: 'pill-b' })[e] || 'pill-b'; },
    fmt(n) { return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 }).format(Number(n || 0)); },
    fmtDate(d) {
      if (!d) return '—';
      // Backend devuelve YYYY-MM-DD o ISO con hora; parsear sin shift UTC → local
      const m = String(d).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) return `${parseInt(m[3], 10)}/${parseInt(m[2], 10)}/${m[1]}`;
      return new Date(d).toLocaleDateString('es-AR');
    }
  }
};
</script>

<style scoped>
.spin { animation: spin 1s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
</style>
